import { useDeck } from '../lib/deckContext';
import { RENDER_KINDS } from '../lib/deck';
import type { LayoutListItem } from '../lib/api';

interface Props {
  layout: LayoutListItem;
}

export function AddToDeckButton({ layout }: Props) {
  const { deck, addLayout, removeLayout, setAllRenders } = useDeck();
  const item = deck.items.find((i) => i.layoutCode === layout.code);

  const selected = item?.selectedRenders.length ?? 0;
  const total = RENDER_KINDS.length;
  const inDeck = selected > 0;
  const allSelected = selected === total;

  const handleClick = () => {
    if (!item) {
      addLayout(layout);
    } else if (allSelected) {
      removeLayout(layout.code);
    } else {
      // Partial selection — promote to "all renders" (most common intent)
      setAllRenders(layout.code, [...RENDER_KINDS]);
    }
  };

  const label = !inDeck
    ? '+ Add all renders'
    : allSelected
      ? '✓ All in deck — remove'
      : `+ Add the other ${total - selected}`;

  return (
    <button
      type="button"
      onClick={handleClick}
      className={`rounded-lg px-5 py-2.5 text-sm font-medium transition-colors ${
        allSelected
          ? 'bg-vari-green text-vari-navy hover:bg-vari-green/80'
          : 'bg-vari-navy text-white hover:bg-vari-blue-accessible'
      }`}
    >
      {label}
    </button>
  );
}
